import React from 'react';
import styled, { keyframes } from 'styled-components';
import tw from 'twin.macro';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

const pulse = keyframes`
  0% {
    background-color: rgba(226, 232, 240, 0.6);
  }
  50% {
    background-color: rgba(226, 232, 240, 0.8);
  }
  100% {
    background-color: rgba(226, 232, 240, 0.6);
  }
`;

const SkeletonBase = styled.div<{
  $width?: string;
  $height?: string;
  $borderRadius?: string;
}>`
  ${tw`bg-bg-secondary`}
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '1rem'};
  border-radius: ${props => props.$borderRadius || '0.25rem'};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const Skeleton: React.FC<SkeletonProps> = ({ width, height, borderRadius, className }) => {
  return (
    <SkeletonBase
      $width={width}
      $height={height}
      $borderRadius={borderRadius}
      className={className}
    />
  );
};

export default Skeleton;
